import { atom } from "recoil";

export const storeDetailState = atom({
  key: "storeDetailState",
  default: null,
});
